namespace GeniuzPOS.Purchase {
    export class ReportPurTaxLongColumns {
        static columnsKey = 'Purchase.ReportPurTaxLong';
    }
}
